<template>
  <v-card class="elevation-12 ma-4">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t("login.title") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span><flag :iso="$i18n.locale.split('-')[1]" /></span>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="item in Object.keys(this.$i18n.messages)"
            :key="item"
            @click="$i18n.locale = item">
            <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text class="v-card__text">
      <v-alert :value="incorrect" type="error" transition="scale-transition" >
        {{ $t("login.incorrect") }}
      </v-alert>
      <v-alert :value="confirmationError" type="error" transition="scale-transition" >
        {{ $t("login.confirmationError") }}
      </v-alert>
      <v-alert :value="confirmed" type="success" transition="scale-transition" >
        {{ $t("login.confirmed") }}
      </v-alert>
      <v-form ref="form" v-model="valid">
        <v-text-field prepend-icon="person" name="email"
          :label="$t('profile.email')" type="email" v-model="credentials.UserName"
          :rules="[rules.required, rules.email]" />
        <v-text-field id="password" prepend-icon="lock" name="password" 
          :rules="[rules.required]"
          :label="$t('profile.password')" type="password" v-model="credentials.Password" 
          @keypress="keyPress"/>
      </v-form>
    </v-card-text>
    <v-card-actions class="v-card__actions">
      <v-spacer></v-spacer>
      <router-link to="/password-reset">{{ $t('login.forgotPassword') }}</router-link> 
      &nbsp;&nbsp;&nbsp;&nbsp;
      <router-link to="/registration">{{ $t('registration.title') }}</router-link> 
      &nbsp;&nbsp;&nbsp;&nbsp;
      <v-btn color="primary" v-on:click="submitLogin" >{{ $t("login.title") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {
    VForm,
    VTextField,
    VCard,
    VCardActions,
    VCardText,
    VBtn,
    VAlert,
    VListItem,
    VListItemTitle
  } from 'vuetify/lib'
import fccapi from '../fccapi';

  export default {
    name: 'FCCLogin',
    data: () => ({
      drawer: null,
      genders: ["Male", "Female"],
      dateofbirth: "",
      credentials: {UserName: "", Password: ""},
      incorrect: false,
      valid: false,
      confirmationError: false,
      confirmed: false
    }),
    methods: {
      submitLogin: function () {
        if(this.valid){
          this.incorrect = false;
          this.$store.dispatch('authRequest', this.credentials).then(() => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded"+e.language)
              this.$i18n.locale = e.language;
              this.$router.push('app/dashboard');
            }).catch((er) => {
              console.log("error: "+er)
              console.log("couldnt load base data")
              this.$router.push('app/dashboard');
            })
            
          }).catch(() => {
            this.incorrect = true;
          });  
        }
        else{
          this.$refs.form.validate();
        }
      },
      keyPress(key) {
        if(key.keyCode == 13) this.submitLogin();
      }
    },
    mounted: function(){
      if(this.$route.query.user && this.$route.query.confirmation){
        fccapi.post('confirm', {User: this.$route.query.user, Code: this.$route.query.confirmation})
          .then(r => {
            console.log(r);
            this.confirmed = true;
          }).catch(e => {
            console.log(e);
            this.confirmationError = true;
          })
      }
      
      console.log("mounted")
    },
    computed: {
      rules: function(){
        return {
          required: value =>  !!value || this.$t('registration.required'),
          email: value => {
            const pattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
            return pattern.test(value) || this.$t('registration.invalidEmail')
          }
        }
      },
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VBtn,
      VAlert,
      VListItem,
      VListItemTitle
    }
  }
</script>